import React from "react";
import { CollapsiblePersistent } from "lib/Collapsible";
import "./CollapsibleFilter.scss";

export function CollapsibleFilter({ children, label, icon, isHighlighted, className }) {
  return (
    <CollapsiblePersistent
      id={label}
      header={header(label, icon, isHighlighted)}
      className={`pb-2 mb-3 ml-n3 pl-3 pr-2 ${className}`}
    >
      {children}
    </CollapsiblePersistent>
  );
}

export const header = (label, icon, isHighlighted) =>
  function innerFunction(toggleOpen, isOpen) {
    return (
      <header
        onClick={toggleOpen}
        className={`collapsible-header cursor-pointer ml-n2 py-1 mb-1 whitespace-pre ${isHighlighted ? "text-primary" : ""}`}
      >
        <i className={`fa fa-fw ${isOpen ? "fa-angle-down" : "fa-angle-right"}`} />
        <i className={`pr-2 fa-fw mr-2 ${icon}`} />
        {label}
      </header>
    );
  };
